<template>
    <div class="header">
        <div class="logoWrap">
            <img src="../assets/images/logo.png" alt="fc" class="logo"
            @click="routeGo('home')"/>
        </div>
        <div class="storeName">{{ sstore }}
        </div>
        <div class="option">
            <div class="storeVip" :class="[vipState === 1 ? 'width160' : 'width230']" @click="goVipExplain">
                <div class="vipImg">
                    <img v-if="vipState === 1" src="../assets/images/is_vip.png" />
                    <img v-else src="../assets/images/not_vip.png" />
                </div>
                <div class="vipMark">枫车Plus</div>
                <div class="vipState">
                    {{ vipText }}
                    <span v-show="vipState !== 1">,</span>
                    <span v-show="vipState !== 1" class="goVipExplain">{{ vipState === 0 ? '点我开通' : '点我续费' }}</span>
                </div>
            </div>
            <div class="itemBox">
                <span class="item openSms"
                    v-show="authList.indexOf('7') >= 0"
                    :class="$route.name === 'Sms' ? 'active' : ''"
                    @click="routeGo('openSms')">购买短信营销包</span>
                <span class="item openOrder"
                    v-show="authList.indexOf('7') >= 0"
                    :class="$route.name === 'open' ? 'active' : ''"
                    @click="routeGo('open')">收银开单</span>
                <span class="item openCard"
                    v-show="authList.indexOf('8') >= 0"
                    :class="$route.name === 'openCard' ? 'active' : ''"
                    @click="routeGo('openCard')">营销售卡</span>
                <span class="item prePaid"
                    v-show="authList.indexOf('9') >= 0"
                    :class="$route.name === 'prePaid' ? 'active' : ''"
                    @click="routeGo('prePaid')">储值卡充值</span>
            </div>
            <!-- <div class="exit" @click="exit()">退出登录</div> -->
            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper">
                    <div class="authInfo" v-if="auth && auth.user_name">
                        {{ auth.user_name }} <span>({{ auth.role_name }})</span>
                        <i class="el-icon-arrow-down color-33" />
                    </div>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><div class="exit" @click="exit()">退出登录</div></el-dropdown-item>
                    <!-- <el-dropdown-item divided>
                    </el-dropdown-item> -->
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="navBox">
            <div class="storeVip" :class="[vipState === 1 ? 'width160' : 'width230']" @click="goVipExplain">
                <div class="vipImg">
                    <img v-if="vipState === 1" src="../assets/images/is_vip.png" />
                    <img v-else src="../assets/images/not_vip.png" />
                </div>
                <div class="vipMark">枫车Plus</div>
                <div class="vipState">
                    {{ vipText }}
                    <span v-show="vipState !== 1">,</span>
                    <span v-show="vipState !== 1" class="goVipExplain">{{ vipState === 0 ? '点我开通' : '点我续费' }}</span>
                </div>
            </div>
            <div class="tabBox"
                @click="showTab = !showTab">
                <div class="tabCnt"
                    :class="showTab ? 'show' : 'hide'">
                    <div class="tabItem"
                        @click="routeGo('openSms')"
                        v-show="authList.indexOf('7') >= 0">
                        <div class="itemIcon">
                            <img src="../assets/images/home_bottom_iconSms.png" alt="">
                        </div>
                        <div class="itemCnt">购买短信营销包</div>
                    </div>
                    <div class="tabItem"
                        @click="routeGo('open')"
                        v-show="authList.indexOf('7') >= 0">
                        <div class="itemIcon">
                            <img src="../assets/images/home_bottom_icon1.png" alt="">
                        </div>
                        <div class="itemCnt">收银开单</div>
                    </div>
                    <div class="tabItem"
                        @click="routeGo('openCard')"
                        v-show="authList.indexOf('8') >= 0">
                        <div class="itemIcon">
                            <img src="../assets/images/home_bottom_icon3.png" alt="">
                        </div>
                        <div class="itemCnt">营销售卡</div>
                    </div>
                    <div class="tabItem"
                        @click="routeGo('prePaid')"
                        v-show="authList.indexOf('9') >= 0">
                        <div class="itemIcon">
                            <img src="../assets/images/home_bottom_icon6.png" alt="">
                        </div>
                        <div class="itemCnt">储值卡充值</div>
                    </div>
                </div>
            </div>
            <div class="exit" @click="exit()">退出登录</div>
        </div>

        <el-dialog
            class="vipDialog"
            title="枫车Plus会员到期提醒"
            width="600px"
            top="25vh"
            :append-to-body="true"
            :close-on-click-modal="false"
            :visible.sync="vipRemindShow">
            <div class="vipDialogText" v-html="vipDialogText"></div>
            <span slot="footer">
                <el-button
                    class="closeBtn"
                    @click="vipRemindShow = false">再等等</el-button>
                <el-button
                    type="primary"
                    class="submitBtn"
                    @click="goVipExplain">{{ vipState === 1 ? '立即延期' : '立即开通' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script lang="babel">
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import { date, localStorage } from 'fengche-utils';
import { clearBrandSession } from '../utils/session';

export default {
    name: 'HeaderBar',
    data() {
        return {
            showTab: false,
            vipState: 0, // 0未开通,1有效,2到期
            vipText: '您还未开通会员',
            vipRemindShow: false,
            vipDialogText: '',
            timeout10: null, // 10点的setTimeout
            interval10: null, // 10点的setInterval
            timeoutExpire: null, // 到期的setTimeout
        };
    },
    computed: {
        ...mapState({
            sstore: ({ appInfo }) => appInfo.sstore,
            authList: ({ appInfo }) => appInfo.authList,
            auth: ({ appInfo }) => appInfo.auth,
        })
    },
    watch: {
        // $route: {
        //     deep: true,
        //     handler(route) {
        //         if (route.name !== 'login') {
        //             this.getUserAuth();
        //         }
        //     }
        // }
    },
    async mounted() {
        // 自定义
        this.getUserAuth();
        this.getVipState();
        // 设置每天10点轮询一次,以防vip续费后计时器未更新导致错误提示
        const initTime = await this.getServiceDate();
        this.timeout10 = setTimeout(() => {
            this.getVipState();
            this.interval10 = setInterval(() => {
                this.getVipState();
            }, 24 * 3600000);
            this.timeout10 = null;
        }, new Date(`${date.formatTime(new Date(initTime + 86400000), 'yyyy-MM-dd')} 10:00:00`).getTime() - initTime);
    },
    beforeDestroy() {
        // 清除计时器(退出登录,切换账号,token失效等情况)
        if (this.timeout10 !== null) {
            clearTimeout(this.timeout10);
        }
        if (this.interval10 !== null) {
            clearInterval(this.interval10);
        }
        if (this.timeoutExpire !== null) {
            clearTimeout(this.timeoutExpire);
        }
    },
    methods:{
        ...mapActions([
            'userLogout',
            'getUserAuth',
        ]),
        routeGo(name) {
            if (!name) return;
            if (name === 'openSms') {
                window.open('https://www.carisok.net/yxdx', '_blank');
            } else {
                this.$router.push({
                    path: name,
                });
            }
        },
        exit() {
            this.userLogout().then(() => {
                // Vue.$storage.remove('STORE_SERVICE');
                Vue.$storage.remove('CAR_NUM_CACHE');
                Vue.$storage.remove('COMPANY_CACHE');
                clearBrandSession();
                this.routeGo('login');
            });
        },
        async getServiceDate() {
            // 获取服务器时间,避免使用本地时间时可以通过修改本地时间影响逻辑
            const res = await Vue.$ajax.get('getServiceDate');
            let time = new Date();
            if (!res.errorType) {
                time = res.time * 1000;
            } else if (res.errcode !== 106) {
                this.$message({
                    message: res.errmsg || '获取服务器时间出错',
                    type: 'error',
                    duration: 2000
                });
            }
            return time;
        },
        async getVipState(notZero = 1) {
            const res = await Vue.$ajax.get('getStoreVipInfo');
            if (!res.errorType) {
                const endDate = date.formatTime(new Date(res.endDate * 1000), 'yyyy-MM-dd');
                this.vipState = res.vipState;
                if (res.vipState === 1) {
                    // 有效
                    this.vipText = `${endDate}到期`;
                    const time = await this.getServiceDate();
                    // 判断到期前7天
                    const remainingTime = (res.endDate * 1000) - time;
                    if (remainingTime < 604800000) {
                        const vipWillExpire = JSON.parse(localStorage.get('VIPWILLEXPIRE'));
                        const today = date.formatTime(new Date(time), 'yyyy-MM-dd');
                        if (!vipWillExpire || vipWillExpire.date !==  today || (vipWillExpire.date ===  today && vipWillExpire.promptedUser.indexOf(res.userName) === -1)) {
                            // 记录在localStorage
                            let val = {};
                            if (!vipWillExpire || vipWillExpire.date !==  today) {
                                val = {
                                    date: today,
                                    promptedUser: [res.userName]
                                };
                            } else {
                                val = JSON.parse(JSON.stringify(vipWillExpire));
                                val.promptedUser.push(res.userName);
                            }
                            localStorage.set('VIPWILLEXPIRE', val);
                            // 弹窗
                            this.vipDialogText = `您的枫车Plus会员即将在<span class="vip-data">${endDate}</span>到期，届时您将失去爱车卡到期提醒、营销活动到期提醒等功能，请及时续费`;
                            this.vipRemindShow = true;
                        }
                        // 如小于14小时,设置到期后检查更改vip状态, 不弹窗,次日10点轮询再弹
                        if (remainingTime < 50400000) {
                            this.timeoutExpire = setTimeout(async () => {
                                this.timeoutExpire = null;
                                // 0点到期时只改变状态
                                this.getVipState(0);
                            }, remainingTime + 1000);
                        }
                    }
                } else if (res.vipState === 2) {
                    // 过期
                    this.vipText = '您的会员已过期';
                    if (notZero) {
                        const vipExpire = JSON.parse(localStorage.get('VIPEXPIRE'));
                        if (!vipExpire || vipExpire.date !==  endDate || (vipExpire.date ===  endDate && vipExpire.promptedUser.indexOf(res.userName) === -1)) {
                            // 记录在localStorage
                            let value = {};
                            if (!vipExpire || vipExpire.date !==  endDate) {
                                value = {
                                    date: endDate,
                                    promptedUser: [res.userName]
                                };
                            } else {
                                value = JSON.parse(JSON.stringify(vipExpire));
                                value.promptedUser.push(res.userName);
                            }
                            localStorage.set('VIPEXPIRE', value);
                            // 弹窗
                            this.vipDialogText = `您的VIP已在<span class="vip-data">${endDate}</span>到期，您已失去爱车卡到期提醒、营销活动到期提醒等功能，请及时恢复`;
                            this.vipRemindShow = true;
                        }
                    }
                } else if (res.vipState === 0) {
                    // 未开通
                    this.vipText = '您还未开通会员';
                }
            } else if (res.errcode !== 106) {
                this.$confirm('服务器出错，是否尝试再次获取vip信息？', '提示', {
                    confirmButtonText: '获取',
                    cancelButtonText: '取消',
                    closeOnClickModal: false,
                    type: 'error'
                }).then(() => {
                    this.getVipState();
                }).catch(() => {});
            }
        },
        goVipExplain() {
            this.vipRemindShow = false;
            this.$router.push({
                path: '/vipExplain',
            });
        },
    }
};
</script>
<style lang="stylus">
@import '../assets/styles/variables';
@import '../assets/styles/mixins';

.header
    height rem(68)
    position fixed
    left 0
    right 0
    top 0
    z-index 100
    background $fcWhite
    padding rem(10) rem(0) rem(10) rem(44)
    display flex
    align-items center
    .logoWrap
        width rem(142)
        padding 0 rem(40) 0 0
        height rem(34)
        img
            cursor pointer
            height rem(34)
    .storeName
        font-size $font24
        font-weight 600
        padding-left rem(10)
        flex auto
        overflow hidden
        line-height rem(38)
        height rem(38)
        text-overflow ellipsis
        white-space nowrap
        width 400px
        padding-right rem(10)
    .storeVip
        margin-right 40px
        position relative
        height 38px
        cursor pointer
        .vipImg
            margin 2px
            height 34px
            width 34px
            img
                width 34px
                height 34px
        .vipMark
            position absolute
            left 46px
            top 0
            font-size 18px
            height rem(18)
            line-height rem(18)
            color #dba46e
        .vipState
            position absolute
            left 46px
            top 24px
            font-size 14px
            height rem(14)
            line-height rem(14)
            color #999
            .goVipExplain
                color $themeColor
    .width160
        width 160px
    .width230
        width 230px
    .navBox
        display none
        @media only screen and (max-width: 1360px)
            display flex
            align-items center
        .exit
            flex auto
            line-height rem(30)
            padding 0 rem(15)
            cursor pointer
            color $fcGreyish
            border-left 1px solid #d5d5d5
        .tabBox
            cursor pointer
            position relative
            margin-right rem(30)
            width rem(30)
            height rem(30)
            background-image url('../assets/images/tabIcon.png')
            background-repeat no-repeat
            background-size rem(20) rem(20)
            background-position center
            .hide
                display none
            .tabCnt
                position absolute
                top rem(45)
                left rem(-100)
                // opacity 0.8
                background rgba(0,0,0, .9)
                color $fcWhite
                border-radius rem(10)
                z-index 101
                padding 0 rem(5)
                .tabItem
                    cursor pointer
                    padding rem(10)
                    display flex
                    width rem(180)
                    border-top 1px solid #d5d5d5
                    &:first-child
                        border-top none
                    .itemIcon
                        width rem(30)
                        img
                            width rem(30)
                            height rem(30)
                    .itemCnt
                        flex 1
                        padding-left rem(10)
                        line-height rem(30)

    .option
        @media only screen and (max-width: 1360px)
            display none
        justify-content flex-end
        height rem(35)
        line-height rem(35)
        flex auto
        justify-content flex-end
        color $fcGreyish
        display flex
        .itemBox
            display flex
            // padding-right rem(30)
            .item
                cursor pointer
                background-repeat no-repeat
                background-size contain
                padding-left rem(52)
                position relative
                margin-right rem(30)
            .openSms
                background-image url('../assets/images/home_bottom_iconSms.png')
                min-width rem(170)
            .openOrder
                background-image url('../assets/images/home_bottom_icon1.png')
                min-width rem(120)
            .openCard
                background-image url('../assets/images/home_bottom_icon3.png')
                min-width rem(120)
            .prePaid
                background-image url('../assets/images/home_bottom_icon6.png')
                min-width rem(150)
            .item
                &.active
                    color #333
                    &::after
                        content ''
                        display block
                        width 68px
                        height 4px
                        background $themeColor
                        position absolute
                        left 52px
                        bottom -10px
            .prePaid.item.active::after
                width 86px
        .exit
            cursor pointer
            min-width rem(160)
            border-left 1px solid #d5d5d5
            text-align center
        .authInfo
            padding 0 rem(60) 0 rem(18)
            color #333
            font-weight 600
            text-overflow: ellipsis;
            white-space: nowrap;
            //background url('../assets/images/user_i.png')
            //background-repeat no-repeat
            //background-size contain
            span
                color $themeColor
        .color-33
                color #333
                font-weight 600
        .avatar-container
            // min-width 248px
@media print
    .header
        display none
.el-dialog__wrapper.vipDialog
    z-index 9999 !important
    .el-dialog
        border-radius 20px
        .el-dialog__header
            border-radius 20px 20px 0 0
            height 80px
            .el-dialog__title
                color #fff
                line-height 40px
                font-size 20px
                font-weight bold
                margin-left 10px
            .el-dialog__headerbtn
                top 25px
        .el-dialog__body
            padding 53px 60px 43px 60px
            .vipDialogText
                color #333
                font-size 16px
                line-height 30px
                text-align center
                .vip-data
                    color #f56c6c
                    padding 0 3px
        .el-dialog__footer
            text-align center
            button
                width 160px
                height 48px
                margin 0 28px 4px
</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue